import {
  buttonIconStyle,
  buttonPrimaryStyle,
  buttonSecondaryStyle,
  buttonSubtleStyle,
  buttonSubtleLinkStyle,
  buttonTertiaryStyle,
  buttonTransparentStyle,
} from "./styles/button";

export const BUTTON_APPEARANCE = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  ICON: "icon",
  SUBTLE: "subtle",
  TERTIARY: "tertiary",
  TRANSPARENT: "transparent",
  LINK: "link",
};

export const BUTTON_STYLE = {
  [BUTTON_APPEARANCE.PRIMARY]: buttonPrimaryStyle,
  [BUTTON_APPEARANCE.SECONDARY]: buttonSecondaryStyle,
  [BUTTON_APPEARANCE.ICON]: buttonIconStyle,
  [BUTTON_APPEARANCE.SUBTLE]: buttonSubtleStyle,
  [BUTTON_APPEARANCE.LINK]: buttonSubtleLinkStyle,
  [BUTTON_APPEARANCE.TERTIARY]: buttonTertiaryStyle,
  [BUTTON_APPEARANCE.TRANSPARENT]: buttonTransparentStyle,
};
